<template>
  <v-app-bar
    :prominent="$vuetify.breakpoint.lgAndUp && $vuetify.breakpoint.height > 800"
    :clipped-right="$vuetify.breakpoint.smAndUp"
    :color="$store.state.event.brandingBannerBackgroundColor"
    dark
    fixed
    app
    class="header-toolbar"
    :src="$store.state.event.brandingBannerUrl || ''"
  >
    <template v-slot:img="{ props }">
      <v-img
        :contain="$store.state.event.brandingBannerExtend === 'Contain'"
        v-bind="props"
        :position="
          $store.state.event.brandingBannerHorizontalAlign + ' ' + $store.state.event.brandingBannerVerticalAlign
        "
      ></v-img>
    </template>
    <div class="participant-header-wrapper">
      <div class="d-flex flex-row align-center">
        <div class="img-container text-center" v-if="!!$store.state.event.brandingLogoUrl"></div>
        <div class="text-container" v-if="!$store.state.event.brandingBannerUrl">
          <p class="participant-event-title mb-0 mb-md-1">
            {{ $store.state.event.name }}
          </p>
        </div>
      </div>
    </div>
    <div class="d-none d-lg-block">
      <v-spacer />
      <lang-switcher />
    </div>
  </v-app-bar>
</template>

<script>
import LangSwitcher from "../../../common/_langSwitcher";

export default {
  name: "ParticipantLayoutHeader",
  components: {
    LangSwitcher,
  },
};
</script>

}
<style scoped lang="scss">
.participant-header-wrapper {
  width: 100%;
  height: 100%;

  .d-flex {
    height: 100%;
  }

  .img-container {
    height: 40px;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .text-container {
    max-width: 700px;
    text-align: center;
    padding-left: 1em;

    .participant-event-title {
      letter-spacing: 1px;
      font-size: 1.2em;
    }
    .participant-event-dsc {
      font-size: 0.5em;
    }
  }
}
@media (min-width: 600px) {
  .participant-header-wrapper {
    .img-container {
      height: 100%;
    }

    .text-container {
      text-align: left;
    }
  }
}
</style>
